import { __ } from '@wordpress/i18n';
import { ColorPalette } from '@wordpress/components';
import { useState,useEffect } from '@wordpress/element';
import { VayuBlocksBlockEditor } from '@vayu-blocks/global';
import { Icon, brush } from '@wordpress/icons';

export const VayuBlocksColor = ({ onChange, background }) => {
  const { value, backgroundKey } = background;
    const blockEditor = VayuBlocksBlockEditor();
    const [colors, setColors] = useState([]);

    useEffect(() => {
      setColors( [
        {
          colors:[
            {
              "name": "Black",
              "slug": "black",
              "color": "#000000"
            },
            {
              "name": "Cyan bluish gray",
              "slug": "cyan-bluish-gray",
              "color": "#abb8c3"
            },
            {
              "name": "White",
              "slug": "white",
              "color": "#ffffff"
            },
            {
              "name": "Pale pink",
              "slug": "pale-pink",
              "color": "#f78da7"
            },
            {
              "name": "Vivid red",
              "slug": "vivid-red",
              "color": "#cf2e2e"
            },
            {
              "name": "Luminous vivid orange",
              "slug": "luminous-vivid-orange",
              "color": "#ff6900"
            },
            {
              "name": "Luminous vivid amber",
              "slug": "luminous-vivid-amber",
              "color": "#fcb900"
            },
            {
              "name": "Light green cyan",
              "slug": "light-green-cyan",
              "color": "#7bdcb5"
            },
            {
              "name": "Vivid green cyan",
              "slug": "vivid-green-cyan",
              "color": "#00d084"
            },
            {
              "name": "Pale cyan blue",
              "slug": "pale-cyan-blue",
              "color": "#8ed1fc"
            },
            {
              "name": "Vivid cyan blue",
              "slug": "vivid-cyan-blue",
              "color": "#0693e3"
            },
            {
              "name": "Vivid purple",
              "slug": "vivid-purple",
              "color": "#9b51e0"
            }
          ],
          name: 'DEFAULT'
        },{
    colors: blockEditor.colors,
    name: 'THEME COLORS'
  }
]);
    }, [blockEditor]);

  const eyePickColor = async () => {
    if ('EyeDropper' in window) {
      try {
        const eyeDropper = new window.EyeDropper();
        const result = await eyeDropper.open();

        const updatedValue = {
            ...value,
            color: result.sRGBHex,
            type:'color'
        };
        onChange(backgroundKey, updatedValue);
      } catch (err) {
        console.error('EyeDropper cancelled or failed:', err);
      }
    } else {
      alert('EyeDropper API is not supported in this browser.');
    }
  }

    return (
      <>
       <Icon className="vb-eyedrop" icon={ brush } onClick={eyePickColor} title="eyeDrop"/>
        <ColorPalette
            className="vb-color-image-conrtrol-border-padding"
            colors={colors}
            value={value?.color}
            enableAlpha
            onChange={(newColor) => {
                const updatedValue = {
                    ...value,
                    color: newColor,
                    type:'color'
                };
                onChange(backgroundKey, updatedValue);
            }}
        />
      </>
    );
};
